(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_finishes"] && !Shopify.designMode) return;
  try {
    class FinishCard extends HTMLElement {
    connectedCallback() {
      // Get the product title element
      const titleElement = this.querySelector('[data-finish-title]');
      if (titleElement) {
        const finish = titleElement.dataset.finishTitle;
        const finishName = window.AM.productNameFromAccr(finish);
        const finishDisplay = finishName
          ? `${finishName.charAt(0).toUpperCase() + finishName.slice(1)} (${finish})`
          : finish;

        // Update the title element with the formatted finish display
        titleElement.textContent = finishDisplay;
      }
    }
  }

  if (customElements.get('finish-card') === undefined) {
    customElements.define('finish-card', FinishCard);
  }
  } catch(e) { console.error(e); }
})();

})();
